import timeOffInputStore from "../store/store";
import { mutatorAction } from "satcheljs";
import { IMemberEntity } from 'sh-models';

export default mutatorAction('SET_MEMBER', function setMemberInStore(member: IMemberEntity) {
    timeOffInputStore.member = member;
});
